/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/styles";
import { Card, CardContent } from "@material-ui/core";
import {
  Autocomplete,
  Stack,
  TextField,
  Checkbox,
  FormControlLabel,
  createFilterOptions,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
}));
function PartnerListCard(props) {
  const {
    data,
    autoCompleteData,
    isViewMode,
    onComplete,
    className,
    ...rest
  } = props;
  const classes = useStyles();

  const handleCheckboxChange = (event) => {
    data.isChecked = !!event.target.checked;
    onComplete(Object.assign({}, data));
  };
  const handleAutocompleteChange = (event, value) => {
    data.company = value;
    onComplete(Object.assign({}, data));
  };
  const handleTextFieldChange = (event) => {
    data.companyName = event.target.value;
    onComplete(Object.assign({}, data));
  };
  const { t } = useTranslation();
  return (
    <Card variant="outlined" className={classes.root}>
      <CardContent>
        <b>{t("VendorSelf.companyList")}</b>
        <br />
        <Stack spacing={3} sx={{ width: "100%" }}>
          <Autocomplete
            disabled={isViewMode}
            multiple
            options={autoCompleteData}
            getOptionLabel={(option) => option.companyName || ""}
            isOptionEqualToValue={(option, value) =>
              option.companyID === value.companyID
            }
            filterOptions={createFilterOptions({
              limit: 20,
            })}
            value={data.company || []}
            renderInput={(params) => <TextField {...params} />}
            onChange={handleAutocompleteChange}
          />
        </Stack>
        <br />
        <FormControlLabel
          control={
            <Checkbox
              disabled={isViewMode}
              checked={!!data.isChecked}
              onChange={handleCheckboxChange}
            />
          }
          label={t("VendorSelf.other")}
        />
        <br />
        <TextField
          disabled={!data.isChecked || isViewMode}
          id="outlined-multiline-static"
          multiline
          rows={3}
          sx={{ width: "100%" }}
          value={data.companyName || ""}
          onChange={handleTextFieldChange}
        />
      </CardContent>
    </Card>
  );
}

PartnerListCard.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
  autoCompleteData: PropTypes.array,
  isViewMode: PropTypes.bool,
};

export default PartnerListCard;
